import type PackageParameters from '../models/PackageParameters';

const defaultPackageParameters: PackageParameters = {
    weight: 1,
    width: 1,
    height: 1,
    depth: 1,
    pallet_number: 1,
};

export default defaultPackageParameters;
